/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class ConfirmationDialogController {
    /** @ngInject */
    constructor($mdDialog, $log, data) {
        this.$mdDialog = $mdDialog;
        this.$log = $log;
        this.titleKey = data.titleKey || 'ui.dialog.confirmation';
        this.messageKey = data.messageKey;
        this.confirmKey = data.confirmKey || 'ui.button.confirm';
        this.cancelKey = data.cancelKey || 'ui.button.cancel';
        this.cancelDisabled = data.cancelDisabled;
        this.$log.debug('Controller \'ConfirmationDialogController\' loaded');
        // Angular Material does not support Angular $onInit hook for controllers yet
        // (see https://github.com/angular/material/issues/9259)
        // That's why it is simulated hereafter. This code shall be removed if the issue above is fixed (expected in
        // Angular Material 1.2.0)
        this.initialized = false;
        this.$onInit();
    }

    $onInit() {
        if (this.initialized) {
            this.$log.warn('ConfirmationDialogController.$onInit called twice: issue 9259 may have been fixed');
        } else {
            this.initialized = true;
        }
    }

    confirm() {
        this.$mdDialog.hide(true);
    }

    cancel() {
        this.$mdDialog.hide(false);
    }
}

export { ConfirmationDialogController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/ConfirmationDialog.js